import { filter } from 'lodash';

const roles = [
  { value: 'stock', name: 'Stock', description: 'Can see stock relevant to their properties', superadmin: false },
  { value: 'orders', name: 'Order Control', description: 'Can see and edit orders relevant to their properties, but not refund', superadmin: false },
  { value: 'reporting', name: 'Reporting', description: 'Can see reports relevant to their properties', superadmin: false },
  { value: 'manager', name: 'Manager', description: 'Property manager, can see and control aspects of their properties', superadmin: false  },
  { value: 'investor', name: 'Investor', description: 'Can see global dashboards', superadmin: true },
  { value: 'premier_admin', name: 'Premier Software Admin', description: 'Can see Integration dashboard and reports', superadmin: true },
  { value: 'admin', name: 'Admin', description: 'Can see information for and administer all hotels and their users', superadmin: true },
  { value: 'superadmin', name: 'Superadmin', description: 'Controls ability to create Admins', superadmin: true },
];

export default ['permissionsService', function(permissionsService) {
  return {
    getRoles() {
      if (permissionsService.user.indexOf('superadmin') > -1) {
        return roles;
      } 
      if (permissionsService.user.indexOf('admin') > -1) {
        return filter(roles, {superadmin: false});
      } 
    }
  };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/user/services/roles.service.js